import React from "react";
import "./style.css";
import Ink from "react-ink";

const FloatingButton = (props) => {
  const { position = "BOTTOM_CENTER" } = props;

  const buildButtonStyles = () => {
    const DISTANCE = 20;
    const style = props.style || {};

    if (position === "BOTTOM_CENTER") {
      return {
        ...style,
        bottom: DISTANCE,
        left: "50%",
        transform: "translateX(-50%)",
      };
    }

    if (position === "BOTTOM_LEFT") {
      return { ...style, bottom: DISTANCE - 7, left: DISTANCE };
    }

    return { ...style };
  };

  return (
    <button
      onClick={props.onClick}
      className="floatingButton_container"
      style={buildButtonStyles()}
    >
      <div
        className="floatingButton_innerContainer"
        style={{ position: "relative" }}
      >
        {props.children}
        <Ink />
      </div>
    </button>
  );
};

export default FloatingButton;
